import { useEffect } from 'react';
import { HashRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';
import WhatsAppModal from './components/WhatsAppModal';
import { WhatsAppProvider } from './context/WhatsAppContext';
import HomePage from './pages/HomePage';
import MenuPage from './pages/MenuPage';
import MarketPage from './pages/MarketPage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';

function ScrollToTopOnRouteChange() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname]);
  return null;
}

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <div key={location.pathname} className="page-transition">
      <Routes location={location}>
        <Route path="/" element={<HomePage />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/market" element={<MarketPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <HashRouter>
      <WhatsAppProvider>
        <ScrollToTopOnRouteChange />
        <Navbar />
        <AnimatedRoutes />
        <Footer />
        <WhatsAppModal />
        <BackToTop />
      </WhatsAppProvider>
    </HashRouter>
  );
}
